import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
import TrustStrip from '@/components/TrustStrip';
import OperationalAP from '@/components/OperationalAP';
import FounderStrip from '@/components/FounderStrip';
import UseCases from '@/components/UseCases';
import ERPIntegrations from '@/components/ERPIntegrations';
import HowItWorks from '@/components/HowItWorks';
import Contact from '@/components/Contact';
import CookieConsent from '@/components/CookieConsent';
import SEO from '@/components/SEO';
import SoftwareApplicationSchema from '@/components/SoftwareApplicationSchema';
import ChatbotDemo from '@/components/ChatbotDemo';
import { useEffect } from 'react';

const Index = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Order per content-v2: Hero → How It Works (5-step Capture/Code/Approve/Post/Pay) →
  // ERP Integrations → Who uses EZ Cloud → Contact. FAQ is removed from the homepage;
  // it does more SEO work on industry pages where query intent is specific.
  return (
    <div className="min-h-screen">
      <SEO
        title="Oracle AP Automation for Fusion & EBS | EZ Cloud"
        description="AP automation engineered for Oracle finance teams. EZ Cloud automates AP operations end-to-end — from supplier-email intake through posting into Oracle Fusion and EBS using Oracle-supported integration methods, plus NetSuite, SAP, Dynamics, and Yardi where you need it."
        canonical="https://ezcloud.ai/"
      />
      <SoftwareApplicationSchema />
      <Navigation />
      <Hero />
      <TrustStrip />
      <OperationalAP />
      <HowItWorks />
      <ERPIntegrations />
      <FounderStrip />
      <UseCases />
      <Contact />
      <CookieConsent />
      <ChatbotDemo />
    </div>
  );
};

export default Index;
